import React, {createContext, useState} from 'react';
import {Toast} from "../components/common/Toast";
import {getErrorMessage} from "../helpers/Utils";
import ReserveService from "../services/ReserveService";

export const ReserveContext = createContext("ReserveContext");

const ReserveContextProvider = ({children}) => {

    const [reserveList, setReserveList] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [loadingReserveList, setLoadingReserveList] = useState(false);
    const [reservedFloorTables, setReservedFloorTables] = useState([]);
    const [loadingReservedFloorTableList, setLoadingReservedFloorTableList] = useState(false);

    const getReserveList = async (restaurantId, params) => {
        try {
            setLoadingReserveList(true);
            const response = await ReserveService.getReserveList(restaurantId, params);
            setReserveList(response.data.content);
            setTotalElements(response.data.totalElements);
            setLoadingReserveList(false);
            return response.data.content;
        } catch (error) {
            setLoadingReserveList(false);
            const message = getErrorMessage(error);
            Toast("error", "Error", message);
            return [];
        }
    }

    const getReservedFloorTables = async (restaurantId, floorId) => {

        try {
            setLoadingReservedFloorTableList(true);
            const response = await ReserveService.getReservedFloorTables(restaurantId, floorId);
            setReservedFloorTables(response.data);
            setLoadingReservedFloorTableList(false);
            return response.data;
        } catch (error) {
            setLoadingReservedFloorTableList(false);
            const message = getErrorMessage(error);
            Toast("error", "Error", message);
            return [];
        }

    }

    return (
        <ReserveContext.Provider
            value={{
                getReserveList,
                getReservedFloorTables,
                reserveList,
                totalElements,
                loadingReserveList,
                reservedFloorTables,
                loadingReservedFloorTableList,
            }}
        >
            {children}
        </ReserveContext.Provider>
    );
}

export default ReserveContextProvider;
